module.exports = __webpack_public_path__ + "static/img/1.824e26a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/1.png
// module id = zaYR
// module chunks = 0